/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BadRequestResponse from '../model/BadRequestResponse';
import CollaborativeCommand from '../model/CollaborativeCommand';
import CommandAcceptedResponse from '../model/CommandAcceptedResponse';
import ErrorResponse from '../model/ErrorResponse';
import InlineObject from '../model/InlineObject';
import ManualOverrideCommandRequest from '../model/ManualOverrideCommandRequest';
import UnprocessableEntityResponse from '../model/UnprocessableEntityResponse';

/**
* Command service.
* @module api/CommandApi
* @version 1.1.0
*/
export default class CommandApi {

    /**
    * Constructs a new CommandApi. 
    * @alias module:api/CommandApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the getCollaborativeCommand operation.
     * @callback module:api/CommandApi~getCollaborativeCommandCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CollaborativeCommand} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get the oldest queued collaborative command for a Fire Controller
     * Retrieves the oldest queued collaborative command for the specified Fire Controller (FIFO), consuming it on read.
     * @param {String} fireControllerId The unique ID of the Fire Controller
     * @param {module:api/CommandApi~getCollaborativeCommandCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CollaborativeCommand}
     */
    getCollaborativeCommand(fireControllerId, callback) {
      let postBody = null;
      // verify the required parameter 'fireControllerId' is set
      if (fireControllerId === undefined || fireControllerId === null) {
        throw new Error("Missing the required parameter 'fireControllerId' when calling getCollaborativeCommand");
      }

      let pathParams = {
        'fireControllerId': fireControllerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = CollaborativeCommand;
      return this.apiClient.callApi(
        '/command/collaboration/{fireControllerId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the manualOverrideCommand operation.
     * @callback module:api/CommandApi~manualOverrideCommandCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommandAcceptedResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Manual Override Command
     * Set a specified Relays current activation/deactivation state
     * @param {String} fireControllerId The unique ID of the Fire Controller
     * @param {module:model/ManualOverrideCommandRequest} manualOverrideCommandRequest Manual override command with state, duration, and delay parameters
     * @param {module:api/CommandApi~manualOverrideCommandCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommandAcceptedResponse}
     */
    manualOverrideCommand(fireControllerId, manualOverrideCommandRequest, callback) {
      let postBody = manualOverrideCommandRequest;
      // verify the required parameter 'fireControllerId' is set
      if (fireControllerId === undefined || fireControllerId === null) {
        throw new Error("Missing the required parameter 'fireControllerId' when calling manualOverrideCommand");
      }
      // verify the required parameter 'manualOverrideCommandRequest' is set
      if (manualOverrideCommandRequest === undefined || manualOverrideCommandRequest === null) {
        throw new Error("Missing the required parameter 'manualOverrideCommandRequest' when calling manualOverrideCommand");
      }

      let pathParams = {
        'fireControllerId': fireControllerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CommandAcceptedResponse;
      return this.apiClient.callApi(
        '/command/manual-override/{fireControllerId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the manualOverrideRequestCommand operation.
     * @callback module:api/CommandApi~manualOverrideRequestCommandCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ManualOverrideCommandRequest} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Manual override command for a Fire Controller by ID
     * @param {String} fireControllerId The unique ID of the Fire Controller
     * @param {module:api/CommandApi~manualOverrideRequestCommandCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ManualOverrideCommandRequest}
     */
    manualOverrideRequestCommand(fireControllerId, callback) {
      let postBody = null;
      // verify the required parameter 'fireControllerId' is set
      if (fireControllerId === undefined || fireControllerId === null) {
        throw new Error("Missing the required parameter 'fireControllerId' when calling manualOverrideRequestCommand");
      }

      let pathParams = {
        'fireControllerId': fireControllerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = ManualOverrideCommandRequest;
      return this.apiClient.callApi(
        '/command/manual-override/{fireControllerId}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the postCollaborativeCommand operation.
     * @callback module:api/CommandApi~postCollaborativeCommandCallback
     * @param {String} error Error message, if any.
     * @param {module:model/CommandAcceptedResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Post a collaborative command for a Fire Controller
     * Queues a collaborative command for the specified Fire Controller. Authorization requires the caller to be an admin or associated with the target Fire Controller. Any caller-supplied duration/validityDuration values are ignored and replaced with Fire-Bridge-defined values.
     * @param {String} fireControllerId The unique ID of the Fire Controller
     * @param {module:model/CollaborativeCommand} collaborativeCommand Collaborative command to queue for the target Fire Controller
     * @param {module:api/CommandApi~postCollaborativeCommandCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/CommandAcceptedResponse}
     */
    postCollaborativeCommand(fireControllerId, collaborativeCommand, callback) {
      let postBody = collaborativeCommand;
      // verify the required parameter 'fireControllerId' is set
      if (fireControllerId === undefined || fireControllerId === null) {
        throw new Error("Missing the required parameter 'fireControllerId' when calling postCollaborativeCommand");
      }
      // verify the required parameter 'collaborativeCommand' is set
      if (collaborativeCommand === undefined || collaborativeCommand === null) {
        throw new Error("Missing the required parameter 'collaborativeCommand' when calling postCollaborativeCommand");
      }

      let pathParams = {
        'fireControllerId': fireControllerId
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['BearerAuth'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = CommandAcceptedResponse;
      return this.apiClient.callApi(
        '/command/collaboration/{fireControllerId}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
